import React, { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { observer } from 'mobx-react-lite'
import { RootStore, RootStoreContext } from '../../stores/rootStore'
import spinner from '../../assets/images/Spinner-1s-55px.gif';

const InvoiceModal = observer(() => {
    const rootStore: RootStore = useContext(RootStoreContext);
    const invoiceStore = rootStore.invoiceStore;
    const {
        closeInvoiceModal, isInvoiceModalOpen, noInvoiceHtml,
        invoiceHtml, postInvoiceDetails, loading,
        invoiceBusinessName, invoiceAddress,
        invoiceRefNumber, country,
        isSubmitClicked, isInvoiceDataValid,
    } = invoiceStore;

    useEffect(() => {
        document.body.style.overflow = isInvoiceModalOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isInvoiceModalOpen]);

    if (!isInvoiceModalOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) closeInvoiceModal();
    };

    if (noInvoiceHtml) {
        return createPortal(
            <div className="inv-modal-back" onClick={handleBackdropClick}>
                <div className="inv-modal" style={{ maxWidth: '480px' }}>
                    <div className="inv-toolbar">
                        <span style={{ fontWeight: 800, fontSize: '.9rem', color: 'var(--text)' }}>Invoice details</span>
                        <button className="inv-close" type="button" onClick={closeInvoiceModal} aria-label="Close">
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
                        </button>
                    </div>
                    <div className="inv-form">
                        <p className="inv-form-sub">Enter your details to generate an invoice for this order.</p>

                        <div className="dcr-field">
                            <label>Name / Business name</label>
                            <input
                                className={invoiceStore.invoiceBusinessNameFieldStyle}
                                name="Name"
                                type="text"
                                value={invoiceBusinessName}
                                onChange={e => invoiceStore.setInvoiceBusinessName(e.target.value)}
                            />
                        </div>
                        <div className="dcr-field">
                            <label>Billing address</label>
                            <textarea
                                className={invoiceStore.invoiceAddressFieldStyle}
                                name="Address"
                                rows={3}
                                value={invoiceAddress}
                                onChange={e => invoiceStore.setInvoiceAddress(e.target.value)}
                                style={{ width: '100%', padding: '11px 13px', border: '1px solid var(--border)', borderRadius: '8px', fontSize: '.9rem', background: 'var(--bg2)', color: 'var(--text)', fontFamily: 'inherit', boxSizing: 'border-box', resize: 'vertical' }}
                            />
                        </div>
                        {country && (
                            <div className="dcr-field">
                                <label>Country</label>
                                <div style={{ fontSize: '.9rem', color: 'var(--text)', padding: '4px 0' }}>{country}</div>
                            </div>
                        )}
                        <div className="dcr-field">
                            <label>Your reference number (optional)</label>
                            <input
                                name="BuyersRefNumber"
                                type="text"
                                value={invoiceRefNumber}
                                onChange={e => invoiceStore.setInvoiceRefNumber(e.target.value)}
                            />
                        </div>

                        <div className="dcr-actions" style={{ marginTop: '8px' }}>
                            {loading ? (
                                <img src={spinner} alt="Loading…" style={{ height: '36px' }} />
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="dcr-btn dcr-btn-primary"
                                        onClick={() => postInvoiceDetails()}
                                        disabled={isInvoiceDataValid === false || isSubmitClicked}
                                    >
                                        Submit details
                                    </button>
                                    <button type="button" className="dcr-btn dcr-btn-outline" onClick={closeInvoiceModal}>
                                        Cancel
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>,
            document.body
        );
    }

    return createPortal(
        <div className="inv-modal-back" onClick={handleBackdropClick}>
            <div className="inv-modal">
                <div className="inv-toolbar">
                    <button className="inv-print" type="button" onClick={() => window.print()}>
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                        Print
                    </button>
                    <button className="inv-close" type="button" onClick={closeInvoiceModal} aria-label="Close">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                </div>
                <div className="inv-doc" dangerouslySetInnerHTML={{ __html: invoiceHtml! }} />
            </div>
        </div>,
        document.body
    );
});

export default InvoiceModal;
